import { reactRoutes, vueRoutes } from '@/common/router';

const exportDefault = {
  isReact: true,
  routes: vueRoutes,
  reactRoutes: reactRoutes,
  packageInfo: {
    name: __PACKAGE_INFO_NAME__,
    dependencies: {},
  },
};

export default exportDefault;
